import ContactStoreCtrl from './contactStore/contactStore.controller';
import HasDropdownDirective from './directives/has-dropdown.directive';
import HilightDirective from './directives/hilight.directive';
import ScrollDirective from './directives/scroll.directive';
import { ImageWithFeatures } from './filters/image-with-features.filter';
import { NotInFilter } from './filters/notIn.filter';
import { TrustedFilter } from './filters/trusted.filter';
import ControlMessagesDirective from './forms/control-messages.directive';
import ControlDirective from './forms/control.directive';
import ApiService from './services/api.service';
import DomService from './services/dom.service';
import LocationService from './shared/location.service';
import StateService from './shared/state.service';
import StoreLocatorCtrl from './store-locator/store-locator.controller';

const MODULE_NAME = 'store-locator';

const app = angular.module(MODULE_NAME, ['ngSanitize', 'jsonFormatter']);

/*
app.config(['$locationProvider', function($locationProvider) {
	$locationProvider.html5Mode(true).hashPrefix('*');
}]);
*/

app.controller('ContactStoreCtrl', ContactStoreCtrl)
	.controller('StoreLocatorCtrl', StoreLocatorCtrl);

app.factory('ApiService', ApiService.factory)
	.factory('DomService', DomService.factory)
	.factory('LocationService', LocationService.factory)
	.factory('StateService', StateService.factory);

app.directive('control', ControlDirective.factory)
	.directive('controlMessages', ControlMessagesDirective.factory)
	.directive('hasDropdown', HasDropdownDirective.factory)
	.directive('hilight', HilightDirective.factory)
	.directive('scroll', ScrollDirective.factory)
// .directive('selectWithAutocomplete', AutocompleteDirective.factory)
// .directive('validate', ValidateDirective.factory)

app.filter('imageWithFeatures', [ImageWithFeatures])
	.filter('notIn', ['$filter', NotInFilter])
	.filter('trusted', ['$sce', TrustedFilter]);

app.run(['$compile', '$timeout', '$rootScope', function($compile, $timeout, $rootScope) {
	DomService.detect();
}]);

export default MODULE_NAME;
